import React from 'react';

/**
 * Base text input. When `label` is omitted the label is expected to be rendered
 * by the parent (e.g. FieldRow). `mask` is a function applied to the typed value.
 */
const TextField = ({
    name,
    label,
    value,
    onChange,
    error,
    required,
    type = 'text',
    multiline = false,
    mask,
    hint,
    ...rest
}) => {
    const id = `psp-${name}`;
    const handleChange = (event) => {
        const next = mask ? mask(event.target.value) : event.target.value;
        onChange(name, next);
    };

    const props = {
        id,
        name,
        value: value === null || value === undefined ? '' : value,
        onChange: handleChange,
        className: `psp-input${error ? ' psp-input--invalid' : ''}`,
        'aria-invalid': !!error,
        'aria-describedby': error ? `${id}-error` : undefined,
        required,
        ...rest
    };

    return (
        <div className="psp-field">
            {label && (
                <label className="psp-field__label" htmlFor={id}>
                    {label}
                    {required && <span className="psp-required">*</span>}
                </label>
            )}
            {multiline ? <textarea {...props} /> : <input type={type} {...props} />}
            {hint && !error && <span className="psp-field__hint">{hint}</span>}
            {error && (
                <span id={`${id}-error`} className="psp-field__error" role="alert">
                    {error}
                </span>
            )}
        </div>
    );
};

export default TextField;
